<section id="login-wrapper" class="min-vh-100" *ngIf="loaded">
  <div class="container login-container">
    <img src="../../../../assets/images/cloudmed-logo-white.svg" alt="" />
    <div class="mx-auto text-center form p-4">
      <h1 class="display-3 py-3 mb-4" id="title">Charge Cat</h1>
      <button class="btn btn-dark btn-lg" (click)="login()">Sign In</button>
    </div>
  </div>
</section>
